import React, { useEffect } from "react";

const Toast = ( props ) => {

  useEffect( () => {
    const timer = setTimeout( props.onHide, props.delay );
    return () => {
      clearTimeout( timer );
    };
  }, [] );

  return (
    <div className="lp-container lc-alert lc-def">
      <p className="lc-alert_txt m-fw-normal">
        { props.children }<br /><br />
      </p>
    </div>
  );

};

Toast.defaultProps = {
  delay : 1500,
  onHide : () => {}
};

export default Toast;
